import getDeviceInfo from '@/lib/base/getDeviceInfo';
const deviceDetails = getDeviceInfo();
const {viewMode} = deviceDetails;
const isMobile = viewMode === 'phone';

export default [
  {
    path: '/cardgolegends',
    name: 'cardgolegends',
    component: () => import('@/views/Cardgolegends/index.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
    },
  },
  {
    path: '/cardgolegends/camera-to-score-game',
    name: 'cardgolegendsCameraToScoreGame',
    component: () => import('@/views/Cardgolegends/CameraToScoreGame.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      isCardgolegends: true,
    },
  },
];
